// Constants values
export const MASTER_USER_ROLE = 'MASTER'
export const MANAGER_USER_ROLE = 'ADMIN'
export const MEMBER_USER_ROLE = 'MEMBER'

// Constants names
export const MASTER_USER_ROLE_NAME = 'Master'
export const MANAGER_USER_ROLE_NAME = 'Gestor'
export const MEMBER_USER_ROLE_NAME = 'Membro'

export const USER_ROLES = [
  MASTER_USER_ROLE,
  MANAGER_USER_ROLE,
  MEMBER_USER_ROLE,
  MASTER_USER_ROLE_NAME,
  MANAGER_USER_ROLE_NAME,
  MEMBER_USER_ROLE_NAME
]
